import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// import { AngularFontAwesomeModule } from 'angular-font-awesome'
import { FlatpickrModule } from 'angularx-flatpickr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { PatientComponent } from './configurator/patient/patient.component'; // NgbdModalContent
import { HeaderComponent } from './header/header.component';
import { TreatmentComponent } from './configurator/patient/treatment/treatment.component';
import { DvmpService } from './shared/services/dvmp.service';
import { DvmpComponent } from './configurator/patient/treatment/treatmentcycles/treatmentcycles';
import { HttpClientModule } from '@angular/common/http';
import { LocalStorageService } from './shared/services/localStorage.service';
import { DoseAndViasCalculationService } from './shared/services/doseAndviaCalculations.service';
import { CalendarDetailsComponent } from './calendar-details/calendar-details.component';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DisplaycalendarComponent } from './calendar-details/displaycalendar/displaycalendar.component';
import { TermsandconditionsComponent, DialogOverviewExampleDialogComponent } from './termsandconditions/termsandconditions.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
// import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { ModaldisclaimerComponent } from './modaldisclaimer/modaldisclaimer.component';
import { PrePostMedicationDialogComponent } from './pre-post-medication-dialog/pre-post-medication-dialog.component';
import { DosisLabelPipe } from '../app/calendar-details/Dosis-Label.pipe';
import { SuperscriptDirective } from './shared/directives/superscript.directive';
import { MarkdownModule } from 'ngx-markdown';

// import { TreatmentModel} from './shared/models/treatment.model';
registerLocaleData(localeEn);

@NgModule({
  declarations: [
    AppComponent,
    ConfiguratorComponent,
    PatientComponent,
    HeaderComponent,
    TreatmentComponent,
    DvmpComponent,
    CalendarDetailsComponent,
    DisplaycalendarComponent,
    TermsandconditionsComponent,
    PagenotfoundComponent,
    DialogOverviewExampleDialogComponent,
    ModaldisclaimerComponent,
    PrePostMedicationDialogComponent,
    DosisLabelPipe,
    SuperscriptDirective
  //  NgbdModalContent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    // AngularFontAwesomeModule,
    HttpClientModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSidenavModule,
    MatSelectModule,
    MatIconModule,
    MatSliderModule,
    MatMenuModule,
    NgbModule,
    MatCardModule,
    BrowserAnimationsModule,
    MarkdownModule.forRoot(),
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  exports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,

],
  entryComponents: [
   // NgbdModalContent,
  //  PrePostMedicationDialogComponent,
  //  ModaldisclaimerComponent,
  //  TermsandconditionsComponent,
  //   DialogOverviewExampleDialogComponent
  ],
  providers: [
    DvmpService,
    LocalStorageService,
    DoseAndViasCalculationService,
    {provide: MAT_DATE_LOCALE, useValue: 'EN'}
  ],
  bootstrap: [AppComponent]

})
export class AppModule {

}
